import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { ApiServiceHolder } from '@core/utils/api-service-holder';
import { PlatformService } from '@shared/services/platform-service.service';
import { Observable, of } from 'rxjs';
import { IUser } from 'src/app/users-manager/interfaces/user.interface';
import { IUserActivationDto, IUserAuthenticateRequest, IUserConnectedDto, IUserEventRegistrationDto, IUserLoginDto, IUserRegistrationDto } from '../interfaces/login.interfaces';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private _api: ApiService,
    private platformService: PlatformService,
  ) {
  }

  register(item: IUserRegistrationDto): Observable<IUser> {
    return this._api.request(ApiServiceHolder.user.register(item));
  }

  registerForEvent(item: IUserEventRegistrationDto): Observable<IUser> {
    return this._api.request(ApiServiceHolder.user.registerForEvent(item));
  }

  activateUser(item: IUserActivationDto): Observable<IUserAuthenticateRequest> {
    return this._api.request(ApiServiceHolder.user.activateUser(item));
  }

  authenticate(item: IUserLoginDto): Observable<IUserAuthenticateRequest> {
    return this._api.request(ApiServiceHolder.user.authenticate(item));
  }

  logout(): Observable<void> {
    return this._api.request(ApiServiceHolder.user.logout());
  }

  ping(): Observable<IUserConnectedDto> {

    return this.platformService.run(
      {
        server: () => {
          return of(null);
        },
        browser: () => {
          return this._api.request(ApiServiceHolder.user.ping());
        }
      }
    );

  }
}
